export const breakpoints = {
  small: 576,
  medium: 768,
  large: 992,
  xlarge: 1470,
};

export const isBreakpoint = (viewportBreakpoint) => {
  const viewportWidth = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0,
  );

  return viewportWidth >= breakpoints[viewportBreakpoint];
};

export const mql = (bp) => {
  return window.matchMedia(`(min-width: ${breakpoints[bp]}px)`);
};

export const addEventListenerOnce = (element, eventType, fn) => {
  element.addEventListener(eventType, (event) => {
    fn(event);
    element.removeEventListener(eventType, fn);
  });

  return element;
};

export const isVisible = (element) => {
  return !!(
    element.offsetWidth ||
    element.offsetHeight ||
    element.getClientRects().length
  );
};

export const getKeyboardFocusableElements = (
  context = document,
  shouldBeVisible = true,
) => {
  const elements = [
    ...context.querySelectorAll(
      'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])',
    ),
  ];

  if (shouldBeVisible) {
    return elements.filter(
      (element) => isVisible(element) && !element.hasAttribute("disabled"),
    );
  }

  return elements.filter((element) => !element.hasAttribute("disabled"));
};

export const onLoadAndResize = (applyCb, resetCb = null) => ({
  apply: () => {
    applyCb();
    window.addEventListener("load", applyCb);
    window.addEventListener("resize", applyCb);
  },
  remove: () => {
    window.removeEventListener("load", applyCb);
    window.removeEventListener("resize", applyCb);
    if (resetCb) {
      resetCb();
    }
  },
});

export const matchToolbarOffset = (context) => {
  return onLoadAndResize(
    () => {
      if (context) {
        context.style.marginTop = document.body.style.paddingTop;
      }
    },
    () => {
      if (context) {
        context.style.marginTop = null;
      }
    },
  );
};

export const updateMainContentOffset = (context) => {
  const mainContentSelector = 'main, [role="main"]';
  const mainContent = document.querySelector(mainContentSelector);
  if (context) {
    return onLoadAndResize(
      () => {
        mainContent.style.paddingTop = `${context.offsetHeight}px`;
      },
      () => {
        mainContent.style.paddingTop = null;
      },
    );
  }
  return false;
};

export class SetGet {
  set(prop, value) {
    this[prop] = value;

    return this;
  }

  get(prop) {
    return this[prop];
  }
}
